import { LitElement, html, render } from 'lit';

// Grid view
import './grid/grid-frame.mjs';

// List view 
import './list/list-frame.mjs';

// Ribbon view
import './ribbon/ribbon-frame.mjs';

// Blank view
import './blank-frame.mjs';

class StudioGalleryItemDisplay extends LitElement {
	static properties = {
		items: { type: Array },
		frame: { type: String },
		item: { type: String },
	};

	constructor() {
		super();
		this.items = [];
		this.frame = 'studio-gallery-blank-frame'; // Default to a blank frame
		this.item = 'studio-card';   // Default to a grid item
	}

	updated(changedProperties) {
		super.updated(changedProperties);

		// Only re-render when necessary properties change
		if (
			changedProperties.has('frame') ||
			changedProperties.has('item') ||
			changedProperties.has('items')
		) {
			this.renderDynamicComponents();
		}
	}

	renderDynamicComponents() {
		const container = this.shadowRoot.querySelector(`#${this.containerId}`);
		if (!container) {
			console.error(`Container with ID ${this.containerId} not found.`);
			return;
		}

		// Clear the container efficiently
		while (container.firstChild) {
			container.removeChild(container.firstChild);
		}

		// Create and append the frame component
		const FrameComponent = customElements.get(this.frame);
		if (!FrameComponent) {
			console.error(`The frame component ${this.frame} does not exist.`);
			return;
		}
		const frameElement = new FrameComponent();

		const { elementName, attributes } = parseItemString(this.item);

		// Create and append each item component to the frame
		this.items.forEach(item => {
			const ItemComponent = customElements.get(elementName);
			if (!ItemComponent) {
				console.error(`The item component ${elementName} does not exist.`);
				console.error(`The full item is ${this.item}.`);
				return;
			}
			const itemElement = new ItemComponent();

			// Set attributes from the parsed string
      Object.entries(attributes).forEach(([key, value]) => {
				itemElement.setAttribute(key, value === true ? '' : value);
      });

      // Apply overriding attributes from item.attributes
      if (item.attributes && typeof item.attributes === 'object') {
	      Object.entries(item.attributes).forEach(([key, value]) => {
  	      itemElement.setAttribute(key, value === true ? '' : value);
        });
      }

			itemElement.metadata = item.metadata || {};

			 if (typeof item.contents === 'string') {
				itemElement.innerHTML = item.contents;
  		} else {
				render(item.contents, itemElement);
			}


			frameElement.appendChild(itemElement);
		});

		// Append the frame to the container
		container.appendChild(frameElement);
	}

	render() {
		// Generate a unique ID for the container to ensure it is targeted
		// correctly
		this.containerId = `container-${Math.random().toString(36).substr(2, 9)}`;
		return html`<div id="${this.containerId}"></div>`;
	}
}

// Helper method to parse item string into element name and attributes
function parseItemString(itemString) {
	const trimmed = itemString.trim();
	const parts = trimmed.split(/\s+(?=(?:[^"]*"[^"]*")*[^"]*$)/);
	const elementName = parts[0];
	const attributes = {};

  // Parse each attribute part
	for (let i = 1; i < parts.length; i++) {
		const attr = parts[i];
		const match = attr.match(/^([^=]+)(?:="([^"]*)")?$|^([^=]+)$/);
		if (match) {
			const key = match[1] || match[3];
			const value = match[2] !== undefined ? match[2] : true;
			attributes[key] = value;
		}
	}

	return { elementName, attributes };
}

customElements.define(
	'studio-gallery-item-display',
	StudioGalleryItemDisplay
);
